import { ApiFetchResponse } from '@terminal/utils/api-fetch/apiFetch';
import { create } from '@terminal/utils/store/createStore';

import { getSettings, updateSettings } from './chat-settings-services';

type ChatSettingsStore = {
  displayPersonalizationDrawer: boolean;
  preferenceFormat?: string;
  setPreferenceFormat: (prompt: string) => Promise<ApiFetchResponse<unknown>>;
  getPreferenceFormat: () => Promise<void>;
  setDisplayPersonalizationDrawer: (display: boolean) => void;
};

export const useChatSettings = create<ChatSettingsStore>(set => ({
  displayPersonalizationDrawer: false,
  preferenceFormat: undefined,

  setDisplayPersonalizationDrawer: (display: boolean) => {
    set({ displayPersonalizationDrawer: display });
  },

  getPreferenceFormat: async () => {
    const response = await getSettings();

    set({ preferenceFormat: response.data?.prompt });
  },
  setPreferenceFormat: async (prompt: string) => {
    const response = await updateSettings(prompt);

    if (!response.error) {
      set({
        preferenceFormat: prompt,
        displayPersonalizationDrawer: false,
      });
    }

    return response;
  },
}));
